import { type GridColDef } from "@mui/x-data-grid";

import { Organization } from "api/memberPortal/orgs/orgs.types";
import { Product } from "api/memberPortal/project/product/product.types";
import LinkButtonCell from "components/MUI/DataGrid/Cells/LinkButton.cell";

const ProductsInFinalReviewColumns: GridColDef<Product>[] = [
  {
    headerName: "VID",
    field: "v_id",
    align: "center",
    flex: 0,
  },
  {
    headerName: "Vendor",
    field: "vendor_id",
    valueGetter: (value: Organization) => value?.name ?? "",
    flex: 2,
  },
  { headerName: "Product", field: "product_name", flex: 2 },

  {
    headerName: "",
    field: "actions",
    sortable: false,
    renderCell: ({ row }) => (
      <LinkButtonCell
        to={`/community/products/details/${row.product_id}`}
        label="REVIEW"
      />
    ),
  },
];

export default ProductsInFinalReviewColumns;
